import React from 'react'

const Corenew = ({FeaturesContent}) => {
  return (
    <div>  <div className="row justify-content-center mt-3">
      {FeaturesContent.map((val, i) => (
        <div
          className="col-lg-6  mb-4"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay={val.dataDealy}
          key={i}
        >
          <div className="block-style-fifteen   h-100 px-3 py-2">
            <div
              className="icon d-flex align-items-center justify-content-center"
               
            >
              <img src={val.icon} alt="icon" />
            </div>
            <h3 className="h3-heading fw-less pt-3 pb-2 lh-sm text-start">{val.title}</h3>
            <p className="h3-para lh-base">{val.desc}</p>
          </div>
        </div>
      ))}
    </div></div>
  )
}

export default Corenew